/**
 * The kit's translator follows the document language, including fallback labels inside overlays.
 * Kit components take labels as options and fall back to `ui.*` keys through this. Owner: UI/Visual (F3).
 */
import { createTranslator, type TFunction } from '../shared';
import { RU_STRINGS } from '../content/strings/ru';
import { EN_STRINGS } from '../content/strings/en';

const translators = {
  ru: createTranslator(RU_STRINGS, { language: 'ru' }).t,
  en: createTranslator(EN_STRINGS, { language: 'en' }).t,
};

/** `t()` for kit components; no browser means Russian for the deterministic test harness. */
export const ut: TFunction = (key, params) => {
  return translators[typeof document !== 'undefined' && document.documentElement.lang === 'en' ? 'en' : 'ru'](key, params);
};
